module.exports = __webpack_public_path__ + "static/media/down-left-arrow.18d2f25c.svg";